import {
  PROFILE_DEFAULT_MESSAGE,
  PROFILE_FALLBACK_MESSAGES,
} from "entities/user";
import { getApiErrorMessage } from "shared/utils";
import type { ApiError } from "shared/utils";

// 401 здесь — invalid_current_password, а не истёкшая авторизация.
const FALLBACK_MESSAGES: Record<number, string> = {
  ...PROFILE_FALLBACK_MESSAGES,
  400: "The new password doesn't meet the requirements.",
  401: "The current password is incorrect.",
  403: "Password change isn't available for this account.",
};

export const getChangePasswordError = (error: ApiError): string | null =>
  getApiErrorMessage(error, FALLBACK_MESSAGES, PROFILE_DEFAULT_MESSAGE);
